import { AfterViewInit, Component } from '@angular/core';
import { AsyncPipe, NgClass } from '@angular/common';
import { Event, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { MatSidenavModule } from '@angular/material/sidenav';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CsAgentAuthService } from '@spartacus/asm/root';
import { CmsService, I18nModule, PageMetaService, RoutingService } from '@spartacus/core';
import { PageSlotModule, SpinnerModule, StorefrontComponent } from '@spartacus/storefront';
import { WindowObject } from '@spartacus/tracking/tms/core';
import { take } from 'rxjs';
import { map } from 'rxjs/operators';
import { UserAccountService } from 'src/feature-libs/kn-br-user/kn-br-account/core/facade';
import { KnBrOutletModule } from 'src/app/common/kn-br-outlet/kn-br-outlet.module';
import { KnBrInactivityReloadService } from '../services/kn-br-inactivity-reload.service';
import { KnBrPdpLoadingService } from '../services/kn-br-pdp-loading.service';
import { KnBrSidebarService } from '../services/kn-br-sidebar.service';
import { KnBrDateFormatService } from 'src/shared/kn-br-date-format.service';
import { OlarkService } from './atg/core/services/olark.service';
import { KnBrConsentManagementPopupComponent } from './atg/kn-br-consent-management/kn-br-consent-management-popup/kn-br-consent-management-popup.component';

@Component({
  selector: 'kn-br-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [
    AsyncPipe,
    NgClass,
    MatSidenavModule,
    PageSlotModule,
    KnBrOutletModule,
    StorefrontComponent,
    SpinnerModule,
    I18nModule,
  ],
})
export class AppComponent implements AfterViewInit {
  title = 'brava-customer';
  pageTitle?: string;
  Url?: string;
  isLoggedInASM = false;
  private isConsentModalOpen = false;
  readonly isNotLoginPage$ = this.cmsService
    .getCurrentPage()
    .pipe(map((page) => page && page.template !== 'KnBrLoginPageTemplate'));
  readonly isHomePage$ = this.routingService
    .getRouterState()
    .pipe(map((routerState) => routerState?.state?.semanticRoute === 'home'));
  readonly menuState$ = this.sidebarService.loadMenuState$();
  readonly pdpLoading$ = this.pdpLoadingService.loading$;
  readonly feedbackSurveyUrl =
    'https://forms.cloud.microsoft/Pages/ResponsePage.aspx?id=fLsbI0sb3EO8tcQOX3Ir5TIVEgCZiKBAhy79yz_0AsdUM0gyMDdHM0tROFdMSEQ2S1BJMUZGWDRRMi4u';
  constructor(
    private cmsService: CmsService,
    private routingService: RoutingService,
    private sidebarService: KnBrSidebarService,
    private router: Router,
    protected csAgentAuthService: CsAgentAuthService,
    protected pageMetaService: PageMetaService,
    private currentUserService: UserAccountService,
    private olarkService: OlarkService,
    private modalService: NgbModal,
    private inactivityReloadService: KnBrInactivityReloadService,
    private pdpLoadingService: KnBrPdpLoadingService,
    private knBrDateFormatService: KnBrDateFormatService
  ) {
    this.inactivityReloadService.init();
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
        this.sidebarService.changeMenuState(false);
      } else if (event instanceof NavigationEnd) {
        setTimeout(() => {
          // element.scrollTop = 0;
          // element.scrollIntoView({ behavior: 'smooth' });
        }, 0);
      }
    });
    this.csAgentAuthService.isCustomerSupportAgentLoggedIn().subscribe((res) => {
      this.isLoggedInASM = res;
    });

    this.currentUserService.get().subscribe((user: any) => {
      if (!user) return;

      if (user?.dateFormat) {
        this.knBrDateFormatService.setDateFormat(user.dateFormat);
      }

      const consentAccepted = this.isConsentAccepted(user?.consentAccepted);
      if (!consentAccepted && !this.isConsentModalOpen) {
        this.isConsentModalOpen = true;
        const modalRef = this.modalService.open(KnBrConsentManagementPopupComponent, {
          centered: true,
          backdrop: 'static',
          keyboard: false,
          windowClass: 'kn-br-consent-management-modal',
        });
        modalRef.componentInstance.user = user;

        modalRef.closed.pipe(take(1)).subscribe((accepted) => {
          this.isConsentModalOpen = false;
          if (accepted === true) {
            user.consentAccepted = true;
          }
        });

        modalRef.dismissed.pipe(take(1)).subscribe(() => {
          this.isConsentModalOpen = false;
        });
      }

      let olarkId = '';

      if (user?.htus || user?.ptus) {
        olarkId = '2224-557-10-3420';
      } else if (user?.htca || user?.ptca) {
        olarkId = '9224-530-10-8355';
      }

      if (olarkId) {
        this.olarkService.loadOlark(olarkId, {
          name: `${user.firstName} ${user.lastName}`,
          email: user.uid,
        });
      }
    });
  }

  ngAfterViewInit() {
    this.initGoogleAnalyticsPageView();
  }

  private initGoogleAnalyticsPageView() {
    const interval = setInterval(() => {
      if ((window as WindowObject).ga && (window as WindowObject).ga.getAll) {
        const ga = (window as WindowObject).ga;
        const tracker = ga.getAll()[0];
        let count = 0;
        this.router.events.subscribe((event) => {
          if (event instanceof NavigationEnd) {
            count = 0;
            this.Url = event.urlAfterRedirects;
          }
        });
        this.pageMetaService.getMeta().subscribe((meta) => {
          count = count + 1;
          this.pageTitle = meta.title;
          if (this.pageTitle) {
            tracker.set('title', this.pageTitle);
          } else {
            tracker.set('title', document.title);
          }

          if (count === 1) {
            tracker.set('page', this.Url);
            tracker.send('pageview');
          }
        });
        clearInterval(interval);
      }
    }, 50);
  }
  _onBackdropClicked() {
    this.sidebarService.changeMenuState(false);
  }
  _onClosed() {
    this.sidebarService.changeMenuState(false);
  }
  _onOpened() {
    this.sidebarService.changeMenuState(true);
  }

  private isConsentAccepted(consentAccepted: any): boolean {
    if (typeof consentAccepted === 'boolean') {
      return consentAccepted;
    }

    if (typeof consentAccepted === 'string') {
      const normalized = consentAccepted.trim().toLowerCase();
      return normalized === 'true' || normalized === '1' || normalized === 'yes' || normalized === 'y';
    }

    if (typeof consentAccepted === 'number') {
      return consentAccepted === 1;
    }

    return false;
  }
}
